export default {
    ContractList: {
      Title: 'Hợp đồng',
      DictionaryContract: '/ Khác / Hợp đồng',
      Dictionary: 'Danh mục',
    },
    FundDetail: {
      FundName: 'Tên quỹ tiền *',
      Description: 'Diễn giải',
      Follow: 'Theo dõi',
    },
};